import React, { useEffect, useState, useContext } from 'react';
import { ButtonType, ContainedButton } from 'atoms/Buttons';
import ImageComponent from 'atoms/Image';
import { isMobileDevice, isCateringDisposition } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';
import { useSelector } from 'react-redux';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';

const LtoBannerComponent = props => {
  const { contentData = {} } = props;
  const { headline, description, desktopImage, mobileImage, button } = contentData;
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const { userOrderStateDispatch } = useContext(UserOrderContext);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { SELECTED_TILE_DATA = '', UPDATE_CATERING_RETAIL_MENU_ALERT } = START_ORDER_CONSTANTS;
  const { CATERING_NAVALERT_TITLE, CATERING_NAVALERT_SUBTITLE } = TRANSLATE_MAPPING_KEY;

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener('resize', windowResized);
  }, [isMobile]);

  const navigateTOViewOffers = () => {
    if (isCateringDisposition(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_TYPE))) {
      userOrderStateDispatch({
        type: UPDATE_CATERING_RETAIL_MENU_ALERT,
        value: {
          flag: true,
          pathname: '',
          title: CATERING_NAVALERT_TITLE,
          contentMsg: CATERING_NAVALERT_SUBTITLE,
        },
      });
      return;
    }

    props.history.push({
      pathname: button?.fields?.url,
    });

    let itemName = {
      name: button?.fields?.name,
    };
    userOrderStateDispatch({ type: SELECTED_TILE_DATA, value: { selectedData: itemName } });
    localStorage.setItem(LOCAL_STORAGE_KEYS.SELECTED_TILE, JSON.stringify(itemName));
    localStorage.setItem(LOCAL_STORAGE_KEYS.TENANT_REDUCER, JSON.stringify(tenantReducer));
  };

  return (
    <React.Fragment>
      <div className='lto-banner-container'>
        <div className='grid-container'>
          <div className='lto-text-section'>
            {headline && <p className='smallTxtLTO'>{headline}</p>}
            {description && <h1 className=' largeTextLTO'>{description}</h1>}
            {button && (
              <ContainedButton
                variant={ButtonType.primary}
                data-testid='view-offer-button'
                onClickHandler={() => navigateTOViewOffers()}
              >
                <span>{button?.fields?.buttonText}</span>
              </ContainedButton>
            )}
          </div>
          <ImageComponent
            data-testid='lto-image-component'
            srcFile={isMobile ? mobileImage?.fields?.file?.url : desktopImage?.fields?.file?.url}
            alt=''
            className='lto-image'
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default LtoBannerComponent;
